import zipcode_to_timezone from 'zipcode-to-timezone'
import { _idx } from '../_idx'
// NOTE: THIS PACKAGE ONLY WORKS IN THE UNITED STATES

export const zipToTimezone = (zipcode: string): string => {
	let timezone = zipcode_to_timezone.lookup(_idx(() => zipcode.split('-')[0]))
	if (!timezone) {
		// guess swanleap time
		timezone = 'America/Chicago'
	}
	return timezone
}
